import React from 'react';
import Header from '../components/Header';
import ContentSection from '../components/ContentSection';
import Footer from '../components/Footer';
import '../styles/App.css';

function Terms() {
  const termsIntro = {
    sectionTitle: (
      <>
        Terms & Conditions <span style={{ color: 'red' }}>&amp; Liability Waiver</span>
      </>
    ),
    sectionDescription: 'Last Updated: December 30, 2025',
    items: [
      {
        title: '',
        body1: (
          <>
            <p>By accessing, registering for, purchasing, or using any services, programs, content, subscriptions, workouts, coaching, or recommendations provided by Begin Strength and Begin the Work, LLC (collectively, the "Company," "we," "us," or "our"), you agree to be bound by these Terms & Conditions ("Terms").</p>
            <p><strong>If you do not agree, do not use the services.</strong></p>
          </>
        ),
      },
    ],
  };

  const termsContent = {
    sectionTitle: '',
    sectionDescription: '',
    items: [
      {
        title: '1. Assumption of Risk',
        body1: (
          <>
            <p>You acknowledge that participation in physical training, exercise, and athletic activity involves inherent risks, including but not limited to muscle strains, sprains, cardiovascular events, illness, injury, permanent disability, or death.</p>
            <p>You voluntarily and knowingly assume all risks, both known and unknown, associated with your participation, whether arising from physical exertion, equipment use, environmental conditions, programming decisions, or otherwise.</p>
          </>
        ),
      },
      {
        title: '2. Medical Clearance & No Medical Advice',
        body1: (
          <>
            <p>The Company does not provide medical advice. All content and services are provided for educational and informational purposes only.</p>
            <p>You agree that it is your sole responsibility to consult with a physician or other qualified healthcare professional before beginning or modifying any exercise or training program, and to determine whether participation is appropriate for your health, fitness level, and medical condition.</p>
          </>
        ),
      },
      {
        title: '3. Personal Responsibility, Execution & Training Environment',
        body1: (
          <>
            <p>You acknowledge that you are solely responsible for your own health, safety, decisions, and actions while participating in any program or activity.</p>
            <p>You agree to modify or discontinue any exercise if you experience pain, discomfort, dizziness, shortness of breath, or other adverse symptoms.</p>
            <p>You acknowledge that improper execution of exercises, misuse of equipment, or failure to follow instructions may increase the risk of injury, and you accept full responsibility for performing all movements safely and correctly.</p>
            <p>You are solely responsible for ensuring that your training environment and any equipment you use are safe, appropriate, and properly maintained, whether training at home, outdoors, or in a commercial facility.</p>
            <p>You acknowledge that training, programming, or coaching may be provided remotely or asynchronously, and that the Company cannot monitor your form, physical condition, surroundings, or readiness during participation.</p>
          </>
        ),
      },
      {
        title: '4. Results Disclaimer',
        body1: (
          <>
            <p>You acknowledge that individual results may vary. The Company makes no guarantees regarding strength gains, fitness improvements, performance outcomes, or health results.</p>
          </>
        ),
      },
      {
        title: '5. Payments, Subscriptions & Billing',
        body1: (
          <>
            <p className="content-subtitle">5.1 Paid Services</p>
            <p>Certain services may require payment ("Paid Services"). By purchasing Paid Services, you agree to the pricing and billing terms presented at checkout.</p>
            
            <p className="content-subtitle">5.2 Payment Authorization</p>
            <p>You authorize the Company (or its third-party payment processor) to charge your selected payment method for all applicable fees, taxes, and charges. You represent that you have the legal right to use the payment method provided.</p>
            
            <p className="content-subtitle">5.3 Payment Processor</p>
            <p>Payments may be processed by a third party (e.g., Stripe, Apple, Google). Your payment information is handled by that provider under its own terms and privacy practices.</p>
            
            <p className="content-subtitle">5.4 Subscriptions & Auto-Renewal</p>
            <p>If you purchase a subscription, it will automatically renew at the end of each billing period (monthly or annual, as disclosed at checkout) unless you cancel before renewal. By subscribing, you authorize recurring charges until cancellation.</p>
            
            <p className="content-subtitle">5.5 Cancellation</p>
            <p>You may cancel your subscription at any time through your account or the platform used to subscribe. Cancellation takes effect at the end of the current paid billing period, and access will continue until that period ends.</p>
            
            <p className="content-subtitle">5.6 Cool-Off Refund Window</p>
            <p>You may cancel an initial purchase for a full refund within ten (10) calendar days of your original transaction. After this period, all purchases are final and non-refundable, except where required by applicable law or expressly stated in writing by the Company.</p>
            
            <p className="content-subtitle">5.7 Price Changes</p>
            <p>We may change prices from time to time. For active subscriptions, any price changes will apply at the next renewal period, following notice as required by law.</p>
            
            <p className="content-subtitle">5.8 Taxes & Currency</p>
            <p>Prices may exclude applicable taxes unless stated otherwise. You are responsible for all applicable taxes. Charges are in U.S. dollars unless otherwise stated at checkout.</p>
            
            <p className="content-subtitle">5.9 Failed Payments & Suspension</p>
            <p>If a payment fails or is reversed, we may retry the charge and/or suspend or terminate access to Paid Services until payment is successfully processed.</p>
            
            <p className="content-subtitle">5.10 Chargebacks</p>
            <p>If you initiate a chargeback or payment dispute, we may suspend your account while the dispute is resolved and provide documentation to contest improper chargebacks.</p>
          </>
        ),
      },
      {
        title: '6. Release of Liability',
        body1: (
          <>
            <p>To the fullest extent permitted by law, you hereby release, waive, and discharge Begin Strength and Begin the Work, LLC, including their owners, officers, employees, contractors, and affiliates, from any and all claims, liabilities, demands, damages, or causes of action, whether arising from negligence or otherwise, related to your use of the services or participation in any program or activity.</p>
          </>
        ),
      },
      {
        title: '7. Indemnification',
        body1: (
          <>
            <p>You agree to indemnify and hold harmless the Company from any claims, losses, damages, liabilities, costs, or expenses (including reasonable attorney's fees) arising out of or related to your use of the services, your participation in training, or your violation of these Terms.</p>
          </>
        ),
      },
      {
        title: '8. Age & Legal Capacity',
        body1: (
          <>
            <p>You represent that you are at least 18 years of age, or have the consent of a parent or legal guardian, and that you have the legal capacity to enter into this agreement.</p>
          </>
        ),
      },
      {
        title: '9. Governing Law; Venue & Jurisdiction',
        body1: (
          <>
            <p>These Terms shall be governed by and construed in accordance with the laws of the State of Oklahoma, without regard to its conflict of law principles.</p>
            <p>Any legal action or proceeding arising out of or relating to these Terms or the services shall be brought exclusively in the state or federal courts located within the State of Oklahoma, and the parties hereby consent to the personal jurisdiction and venue of such courts.</p>
          </>
        ),
      },
      {
        title: '10. Severability',
        body1: (
          <>
            <p>If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions shall remain in full force and effect.</p>
          </>
        ),
      },
      {
        title: '11. Acceptance of Terms',
        body1: (
          <>
            <p>By creating an account, completing a purchase, checking the acceptance box, or using the Company's services, you confirm that you have read, understood, and voluntarily agreed to these Terms & Conditions and Liability Waiver.</p>
          </>
        ),
      },
    ],
  };

  return (
    <div className="home">
      <Header />
      <main>
        <ContentSection
          sectionTitle={termsIntro.sectionTitle}
          sectionDescription={termsIntro.sectionDescription}
          items={termsIntro.items}
          sectionClass="terms-section"
          spacer={true}
        />

        <ContentSection
          sectionTitle={termsContent.sectionTitle}
          sectionDescription={termsContent.sectionDescription}
          items={termsContent.items}
          sectionClass="terms-content-section"
        />

        <Footer />
      </main>
    </div>
  );
}

export default Terms;
















